import routerOptions0 from "/home/gerard/Work/vawarelabs/asufin/asufin-panel-v2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}